// This file is automatically generated. Do not edit manually.

import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SolidWorksToProjectActivityMaterialApi {
	export async function importSolidWorksFileToActivityMaterial(args: {
		projectActivityId: number;
		fileHandle: FrontendUploadFileHandle;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterials/import/solidWorks/importSolidWorksFileToActivityMaterial",
			method: "POST",
			data: {
				projectActivityId: args.projectActivityId,
				fileHandle: args.fileHandle,
			},
		});
		return response as void;
	}
}
